export const phoneMask = {
    mask: "+(99[9]) *{3,14}",
    definitions: {
        '*': {
        validator: "[0-9\-]"
        }
    }
}